export default __webpack_public_path__ + "static/media/4c21eb0392854f50.a110cce2bfeec2b8f665a26764bffd31.svg";